import { Component, OnInit } from '@angular/core';
import { FeedbackStatusFollowUpService } from '../service/feedback-status-followup.service';
import { FileStatusModel } from '../model/file-status.model';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'feedback-status-followup',
  templateUrl: './feedback-status-followup.component.html',
  styleUrls: ['./feedback-status-followup.component.css']
})
export class FeedbackStatusFollowUpComponent implements OnInit {

  userDetails: any;
  accountManagers: any[];
  accountManagerSelected: any = null;
  customers: any[];
  customerSelected: any = null;
  resultTable: any[] = null;
  cols: any[];
  msgs: Message[] = [];
  statusAges: any[];
  statusAgeSelected: any;

  constructor(private dataService: FeedbackStatusFollowUpService, private router: Router, private userService: UserService) { }

  ngOnInit() {
    

    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (!this.userDetails.ClientRoleAdministration && !this.userDetails.ClientRoleSupport && !this.userDetails.ClientRoleSemiAdministrator) {
        return this.showMessage('error', '', 'אינך מורשה למסך זה ');
      }
      this.dataService.getAccountManagersDDL().subscribe((result: any) => {
        this.accountManagers = result;
        if (this.userDetails.ClientRoleSupport && this.accountManagers && this.accountManagers.length==1) {
          this.accountManagerSelected = this.accountManagers[0].value;
        }
        this.accountManagerChanged();
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מנהלי תיקים ');
      });

      
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בבדיקת הרשאות ');
    });

    this.statusAges = [
      {label: 'עד שבועיים', value: ',14'},
      {label: 'מעל שבועיים ועד חודש', value: '15,30'},
      {label: 'מעל חודש', value: '31,'},
      {label: 'הכל', value: ','},
    ];
    this.statusAgeSelected = this.statusAges[0].value;

    this.cols = [
      { field: 'AccountManagerName', header: 'מנהל תיק' },
      { field: 'CustomerIdentityNumber', header: 'מעסיק' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'MISPAR_MEZAHE_OVED', header: 'ת.ז. עובד' },
      { field: 'SHEM_PRATI', header: 'שם פרטי' },
      { field: 'SHEM_MISHPACHA', header: 'שם משפחה' },
      { field: 'CHODESH_MASKORET', header: 'חודש שכר' },
      { field: 'ReportMonth', header: 'חודש דיווח' },
      { field: 'SHEM_KUPA', header: 'שם קופה' },
      { field: 'SUG_HAFRASHA', header: 'סוג הפרשה' },
      { field: 'StatusDescription', header: 'סטטוס הפקדה' },
      { field: 'StatusFollowUpDateFormatted', header: 'תאריך סטטוס' },
      { field: 'StatusAgeInDays', header: 'גיל סטטוס' },
      { field: 'MISPAR_MEZAHE_RESHUMA', header: 'מזהה רשומה' },
      { field: 'OriginalFileName', header: 'שם קובץ' },

    ];
  }

  accountManagerChanged() {
    this.dataService.getCustomersDDL(this.accountManagerSelected).subscribe((result: any) => {
      this.customers = result;
      this.customerSelected = null;
    
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
    });
  }

  getData(): void {
    

    this.dataService.getData(this.accountManagerSelected, this.customerSelected, this.statusAgeSelected).subscribe((result: any) => {
      this.resultTable = result;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת נתונים ');
    });
  }

  

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/feedback-status-followup/feedback-status-followup.component.ts